import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14.79 7.967c.29.3.28.77-.02 1.06l-3.94 3.71 3.94 3.71c.3.29.31.76.02 1.06s-.76.31-1.06.02l-4.5-4.25a.74.74 0 0 1-.23-.54.74.74 0 0 1 .23-.54l4.5-4.25c.3-.29.77-.28 1.06.02"
}));
const ForwardRef = forwardRef(SvgComponent);
export const MenuLeftIcon = ForwardRef;